// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsAllocationsAppModule } from './app.module';
bootstrapAppModule(MutualFundsAllocationsAppModule);
